import { render, staticRenderFns } from "./NsAddressFi.vue?vue&type=template&id=27006bd0&"
import script from "./NsAddressFi.vue?vue&type=script&lang=js&"
export * from "./NsAddressFi.vue?vue&type=script&lang=js&"
import style0 from "./NsAddressFi.vue?vue&type=style&index=0&lang=scss&module=%24x&"




function injectStyles (context) {
  
  this["$x"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports